<app-title-section></app-title-section>

<div class="card p-1"  style="margin-left: 15px; margin-right: 15px">

    <ul class="nav nav-tabs m-0 " style=" border-bottom: 1px solid #eee;">
        <li class="nav-item">
            <a class="nav-link"
               routerLink="tous"
               routerLinkActive="active"
               [class.active]="selectedStatus === 'Tous'"
              >
                Tous
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link"
               routerLink="brouillon"
               routerLinkActive="active"
               [class.active]="selectedStatus === 'Brouillon'"
              >
                Brouillon
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link"
               routerLink="valide"
               routerLinkActive="active"
               [class.active]="selectedStatus === 'Valide'"
             >
                Valide
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link"
               routerLink="cree"
               routerLinkActive="active"
               [class.active]="selectedStatus === 'Créé'"
              >
                Crée
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link"
               routerLink="annule"
               routerLinkActive="active"
               [class.active]="selectedStatus === 'Annulé'"
               >
                Annulé
            </a>
        </li>


    </ul>


    <router-outlet></router-outlet>
</div>



